import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { PRIMARY_NAV_ITEMS } from "../../navigation/tspMenu";

// The 10-tab primary nav from the approved header design. It renders every
// item in PRIMARY_NAV_ITEMS unconditionally — it takes no permission input and
// must not gain one (see the note above PRIMARY_NAV_ITEMS). Access is enforced
// by TspProtectedRoute and the backend, not by hiding tabs.
//
// Items keep a fixed gap (it only tightens on narrower screens) and the row
// scrolls sideways when they cannot fit; the active tab is scrolled into view
// so it is never hidden.
export default function TspNav() {
  const location = useLocation();
  const activeRef = useRef(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView?.({ inline: "nearest", block: "nearest" });
  }, [location.pathname]);

  return (
    <nav className="tsp-nav" aria-label="TSP primary">
      <ul className="tsp-nav-list">
        {PRIMARY_NAV_ITEMS.map((item) => {
          const active = item.isActive(location.pathname);
          return (
            <li key={item.key}>
              <Link to={item.route} ref={active ? activeRef : null} className={`tsp-nav-link ${active ? "active" : ""}`} aria-current={active ? "page" : undefined}>
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
